// extracted by mini-css-extract-plugin
module.exports = {"content":"RichText_content__0h_eg","water":"RichText_water__j2F6F","rotate":"RichText_rotate__MbjcE","pulsate":"RichText_pulsate__Lc26L"};